import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/imaging-procedures/abdominalMri";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	abdominalMri: {
		id: "form.abdominal_mri",
		defaultMessage: "Hasi MRI"
	},
	result: {
		id: "form.abdominal_mri.result",
		defaultMessage: "Eltérés"
	},
	comment: {
		id: "form.abdominal_mri.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	comment: {
		type: "field",
		path: ["resultComment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "abdominalMri",
	value: {
		title: messages.abdominalMri,
		validator,
		fieldset,
		isImportant: true
	}
};
